import React from "react";
import "../styles/Legal.css";
import usePageMeta from "../hooks/usePageMeta";

const POSTS: Array<{ slug: string; title: string; date: string; excerpt: string }> = [];

const BlogPage: React.FC = () => {
  usePageMeta({
    title: "Blog | PabSync",
    description:
      "Product updates, engineering notes, and how teams use PabSync.",
    path: "/blog",
  });

  return (
    <div className="legal-page">
      <main className="legal-container">
        <article className="legal-card">
          <h1 className="legal-title">Blog</h1>
          <p className="legal-meta">Product updates, engineering notes, and how teams use PabSync.</p>

          {POSTS.length === 0 ? (
            <p>
              No posts yet — check back soon. In the meantime, follow product updates on the{" "}
              <a href="/changelog">Changelog</a>.
            </p>
          ) : (
            <ul style={{ listStyle: "none", padding: 0 }}>
              {POSTS.map((p) => (
                <li key={p.slug} style={{ marginBottom: 24 }}>
                  <h2 style={{ marginBottom: 4 }}>{p.title}</h2>
                  <p className="legal-meta">{p.date}</p>
                  <p>{p.excerpt}</p>
                </li>
              ))}
            </ul>
          )}
        </article>
      </main>
    </div>
  );
};

export default BlogPage;
